import React, {useContext, useEffect, useRef, useState} from "react";
import styles from "./Login.module.css";
import {ReactComponent as YuJaLogo} from "../../images/yujalogo.svg";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {ReactComponent as CORRECT_ICON} from './images/IconCorrect.svg';
import {ReactComponent as INCORRECT_ICON} from './images/IconIncorrect.svg';
import EyeOpen from "./images/EyeOpen.svg"
import EyeClosed from "./images/EyeClosed.svg"
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import {
  LOGIN_PATH,
  SCREEN_TYPE
} from "../../utils/constants";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {notifySuccess} from "../../utils/helpers";
import {Button} from "@base-ui/react/button";
import {YuJaGlobalState} from "../../utils/LoadingContext";
import { useTranslation } from "react-i18next";


export default function PasswordResetPage() {
  const { t } = useTranslation();
  const {state={}} = useLocation();
  const {from, loginRedirectState={}} = state;
  const { resetCode, userName } = useParams();
  const {type} = useWindowDimensions();
  const {globalHostResource: hostResource} = useContext(YuJaGlobalState);
  const { imageURL} = hostResource;
  const history = useHistory();
  const [newPw, setNewPw] = useState("");
  const [conPw, setConPw] = useState("");
  const [newPwValid, setNewPwValid] = useState(true);
  const [conPwValid, setConPwValid] = useState(true);
  const [reqConLen, setConReqLen] = useState(true);
  const [reqConUpper, setConReqUpper] = useState(true);
  const [reqConLower, setConReqLower] = useState(true);
  const [reqConNum, setConReqNum] = useState(true);
  const [reqConSpe, setConReqSpe] = useState(true);
  const [reqConPwmatch, setReqConPwmatch] = useState(true);
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [conPasswordShown, setConPasswordShown] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const animation = useRef();
  const resetBtnRef = useRef();
  const testUpperCase = new RegExp("^.*[A-Z]+.*$");
  const testLowerCase = new RegExp("^.*[a-z]+.*$");
  const testSpe = new RegExp("^(?=.*[-+_!@#$%^&*.,?]).+$");

  // const isMobile = window.innerHeight / window.innerWidth > 1 && window.innerWidth < 950;

  const {resetPwd} = AuthenticationApiCalls();


  const inlineStyles = {
    rowStyle: {display: "flex", alignItems: "center", gap: 5},
    inputBoxStyle: {height: 47, fontSize: 15, fontWeight: "400", padding: 12},
    linkStyle: {textDecoration: "underline", fontSize: 16, alignSelf: "center", fontWeight: "600"},
  }

  useEffect(() => {
    if (!!animation.current) {
      animation.current.play();
    }
  }, [resetCode]);

  const handleSubmit = async () => {
    let btn = document.getElementById("YuJa-reset-pwd-btn");
    if (btn.getAttribute("data-disabled") === "true") {
      return;
    }

    setIsProcessing(true);
    //call API to change password
    resetPwd(userName, resetCode, conPw).then((res) => {
      if (!!res) {
        notifySuccess(t("auth.resetPasswordSuccess"));
        goHome();
      }
    }).finally(() => {
      setIsProcessing(false);
    });


  }

  const editPwd = (e) => {
    if(e.target.id === "input-new-pw") {
      setNewPw(e.target.value);
      validatePwd(e.target.value, conPw);
    } else {
      setConPw(e.target.value);
      validatePwd(newPw, e.target.value);
    }
  }

  const validatePwd = (newPwd, conPwd) => {
    let newPwValidCopy = true;
    let conPwValidCopy = true;

    //characters length
    setConReqLen(true);
    if (newPwd.length < 14) {
      newPwValidCopy = false;
      setConReqLen(false);
    }

    //uppercase
    setConReqUpper(true);
    if (!testUpperCase.test(newPwd)) {
      newPwValidCopy = false;
      setConReqUpper(false);
    }

    //lowercase
    setConReqLower(true);
    if (!testLowerCase.test(newPwd)) {
      newPwValidCopy = false;
      setConReqLower(false);
    }


    //number
    setConReqNum(true);
    if (!/\d/.test(newPwd)) {
      newPwValidCopy = false;
      setConReqNum(false);
    }



    //special character
    setConReqSpe(true);
    if (!testSpe.test(newPwd)) {
      newPwValidCopy = false;
      setConReqSpe(false);
    }


    //match
    setReqConPwmatch(true);
    if (newPwd !== conPwd) {
      setReqConPwmatch(false);
      conPwValidCopy = false;
    }


    setNewPwValid(newPwValidCopy);
    setConPwValid(conPwValidCopy);
  }

  const isValid = () => {
    return reqConPwmatch && reqConLen && reqConUpper && reqConLower && reqConNum && reqConSpe;
  }


  const goHome = () => {
    if (!!loginRedirectState && !!Object.entries(loginRedirectState).length) {
      let stateCopy = JSON.parse(JSON.stringify(loginRedirectState));
      delete stateCopy.msg;
      history.push("/" , stateCopy);
    } else {
      history.push({ pathname: "/" });
    }
  }

  const toggleNewPw = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setNewPasswordShown(!newPasswordShown);
    // setTimeout(() => {
    //   const input = document.getElementById('input-new-pw');
    //   input.focus();
    //   input.setSelectionRange(input.value.length + 5, input.value.length  + 5);
    // }, 300)
  }

  const toggleConPw = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setConPasswordShown(!conPasswordShown);
    // document.getElementById('input-con-pw').focus();
  }

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  }

  return (
      <>
        <div
            style={{backgroundImage: !!imageURL ? `url(${imageURL})` : undefined}}
            className={!!imageURL ? styles.imageBackground : styles.gradientBackground}
        />

        <div className={`${styles.container} ${type === SCREEN_TYPE.MOBILE ? styles.mobileContainer : ""}`}>
          <div style={{flex: 1}}/>
          <div className={styles.loginCard}>
            <div className={styles.logoContainer}>
              <YuJaLogo/>
              <span className={styles.mediumText}>{t("auth.resetPassword")}</span>
              <span className={styles.descriptionText}>
                {from === LOGIN_PATH ? t("auth.resetExpiredPasswordDescription") : t("auth.resetNewPasswordDescription")}
              </span>
            </div>

            <div>
              <div style={inlineStyles.rowStyle}>
                <span className={styles.labelText}>{t("auth.newPasswordLabel")}</span>
                <span style={{flex: 1}}/>
              </div>
              <div style={{height: 10}}/>
              <YuJaTextBox
                  containerStyle={inlineStyles.inputBoxStyle}
                  id="input-new-pw"
                  type={newPasswordShown ? "text" : "password"}
                  placeholder={t("auth.newPasswordPlaceholder")}
                  value={newPw}
                  onChange={e => editPwd(e)}
                  onKeyUp={onKeyUp}
                  isInvalid={!newPwValid}
                  after={
                    <>
                      {newPw.length > 0 &&
                          <YuJaTooltip placement={"bottom"} text={t("auth.showOrHidePassword")}>
                            <img
                                tabIndex={0}
                                onClick={toggleNewPw}
                                className={styles.eye}
                                src={newPasswordShown ? EyeOpen : EyeClosed}
                                alt={t("auth.showOrHidePassword")}
                                style={{cursor: "pointer"}}
                            />
                          </YuJaTooltip>
                      }
                    </>
                  }
              />
            </div>


            <div>
              <div style={inlineStyles.rowStyle}>
                <span className={styles.labelText}>{t("auth.confirmNewPasswordLabel")}</span>
                <span style={{flex: 1}}/>
              </div>
              <div style={{height: 10}}/>
              <YuJaTextBox
                  containerStyle={inlineStyles.inputBoxStyle}
                  id="input-con-pw"
                  type={conPasswordShown ? "text" : "password"}
                  placeholder={t("auth.confirmNewPasswordPlaceholder")}
                  value={conPw}
                  onChange={e => editPwd(e)}
                  onKeyUp={onKeyUp}
                  isInvalid={!conPwValid}
                  after={
                    <>
                      {conPw.length > 0 &&
                          <YuJaTooltip placement={"bottom"} text={t("auth.showOrHidePassword")}>
                            <img
                                onClick={toggleConPw}
                                className={styles.eye}
                                src={conPasswordShown ? EyeOpen : EyeClosed}
                                alt={t("auth.showOrHidePassword")}
                                style={{cursor: "pointer"}}
                            />
                          </YuJaTooltip>
                      }
                    </>
                  }
              />
            </div>

            <Button
                id={"YuJa-reset-pwd-btn"}
                className={styles.signInButtonNew}
                onClick={handleSubmit}
                disabled={!!isProcessing || !newPw || !conPw || !isValid()}
                focusableWhenDisabled={!!newPw && !!conPw && isValid()}
            >
              {t("auth.resetPassword")}
            </Button>


            {!isValid() &&
                <div className={styles.pwHintGroupContainer}>
                  <div className={styles.pwHintContainer}>
                    {reqConLen ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleLength")}</span>
                  </div>

                  <div className={styles.pwHintContainer}>
                    {reqConUpper ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleUppercase")}</span>
                  </div>


                  <div className={styles.pwHintContainer}>
                    {reqConLower ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleLowercase")}</span>
                  </div>

                  <div className={styles.pwHintContainer}>
                    {reqConNum ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleNumber")}</span>
                  </div>

                  <div className={styles.pwHintContainer}>
                    {reqConSpe ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleSpecial")}</span>
                  </div>

                  <div className={styles.pwHintContainer}>
                    {reqConPwmatch ? <CORRECT_ICON/> : <INCORRECT_ICON/>}
                    <span>{t("auth.passwordRuleMatch")}</span>
                  </div>
                </div>
            }


            <Button
                className={styles.linkText}
                onClick={goHome}
                style={inlineStyles.linkStyle}
            >
              {t("common.goBack")}
            </Button>

          </div>
          <div style={{flex: 1}}/>
        </div>
      </>
  );
}
